import React from 'react';
import { SectorPageTemplate } from '../components/SectorPageTemplate';
export function SectorZorgpraktijkenPage() {
  return <SectorPageTemplate sectorName="Zorgpraktijken" sectorSlug="zorgpraktijken" heroTitle="Webdesign voor zorgpraktijken" heroDescription="Professionele websites voor fysiotherapeuten, tandartsen, huisartsen en psychologen. Wij bouwen toegankelijke websites die patiënten aantrekken." whyTitle="Waarom een goede website essentieel is in de zorg" whyDescription="Patiënten zoeken online naar zorgverleners. Vertrouwen, toegankelijkheid en duidelijke informatie zijn cruciaal." whyItems={[{
    icon: 'HeartPulseIcon',
    title: 'Toegankelijkheid',
    description: 'Een duidelijke website waar patiënten snel de juiste informatie en contactgegevens vinden.'
  }, {
    icon: 'CalendarCheckIcon',
    title: 'Online afspraken',
    description: 'Verlaag de druk op de telefoon door patiënten online hun afspraken te laten inplannen.'
  }, {
    icon: 'ShieldCheckIcon',
    title: 'Vertrouwen uitstralen',
    description: "Een professionele uitstraling met teamfoto's en specialisaties stelt patiënten gerust."
  }, {
    icon: 'FileTextIcon',
    title: 'AVG-compliant',
    description: 'Veilige formulieren en een privacyverklaring die voldoen aan de strenge eisen in de zorg.'
  }]} features={[{
    icon: 'CalendarCheckIcon',
    title: 'Afspraakformulier',
    description: 'Veilige en gebruiksvriendelijke formulieren voor het inplannen van afspraken of intakes.'
  }, {
    icon: 'UsersIcon',
    title: 'Specialisaties & Team',
    description: "Overzichtelijke pagina's per behandeling en een voorstelpagina van de behandelaars."
  }, {
    icon: 'FileTextIcon',
    title: 'Vergoedingen info',
    description: 'Heldere overzichten van tarieven en contracten met zorgverzekeraars.'
  }]} clusters={[{
    name: 'Fysiotherapie',
    slug: 'fysiotherapie',
    label: 'Fysio',
    description: 'Websites voor fysiotherapiepraktijken en specialisten.'
  }, {
    name: 'Tandarts',
    slug: 'tandarts',
    label: 'Mondzorg',
    description: 'Websites voor tandartsen, mondhygiënisten en orthodontisten.'
  }, {
    name: 'Huisarts',
    slug: 'huisarts',
    label: 'Huisarts',
    description: 'Informatieve websites voor huisartsenpraktijken en gezondheidscentra.'
  }, {
    name: 'Psycholoog',
    slug: 'psycholoog',
    label: 'GGZ',
    description: 'Websites voor psychologen, therapeuten en coaches.'
  }]} faqs={[{
    q: 'Voldoet de website aan de AVG-wetgeving?',
    a: 'Ja, wij zorgen voor veilige (SSL) verbindingen, cookie-meldingen en we kunnen helpen met het veilig inrichten van contactformulieren voor medische gegevens.'
  }, {
    q: 'Kunnen patiënten online afspraken maken?',
    a: 'Zeker. We kunnen een afspraakmodule inbouwen of linken naar jullie bestaande patiëntenportaal of praktijksoftware.'
  }, {
    q: 'Wat kost een website voor een zorgpraktijk?',
    a: "Een professionele praktijkwebsite start vanaf €1.500. De uiteindelijke prijs hangt af van het aantal pagina's (specialisaties) en gewenste functionaliteiten."
  }, {
    q: 'Is de website goed leesbaar voor ouderen?',
    a: 'Wij houden rekening met digitale toegankelijkheid (WCAG-richtlijnen), zoals voldoende contrast, duidelijke lettertypes en een logische navigatie.'
  }]} relatedPages={[{
    name: 'Website laten maken',
    href: '#/website-laten-maken'
  }, {
    name: 'Website beveiliging',
    href: '#/website-beveiliging'
  }]} data-id="element-1684" />;
}